import { FC } from "react"

import { TypographyProps } from "@mui/material"
import Dialog from "components/common/dialog/dialog"
import { useTranslation } from "react-i18next"

interface IProps {
  open: boolean
  onClose: () => void
  onActionButtonClick: () => void
  descriptionText?: string
  descriptionTextProps?: TypographyProps
  children?: React.ReactNode
}

const DialogClearApplication: FC<IProps> = ({
  open,
  onClose,
  onActionButtonClick,
  descriptionText,
  descriptionTextProps,
  children,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onActionButtonClick={onActionButtonClick}
      titleText={t("jobs.areYouSureYouWantToClearAllApplications")}
      descriptionText={descriptionText}
      descriptionTextProps={descriptionTextProps}
      desktopMaxWidth="534px"
      tabletMaxWidth="344px"
      actionAcceptText={t("jobs.clear")}
    >
      {children}
    </Dialog>
  )
}

export default DialogClearApplication
